// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BACKEND: {
    BASE_URL: 'http://maxsystemonlinesale.azurewebsites.net/',
    LOGIN: 'api/Model/Login',
    CONTRACT: 'api/Model/Details',
    CONTRACT_UPDATE: 'api/Model',
    PROFILE_PHOTO: 'api/Model/UploadProfilePhoto',
    GALLERY_PHOTO: 'api/Model/PhotosGallery',
    GALLERY_PHOTO_UPLOAD: 'api/Model/PhotosGallery/Upload',
    GALLERY_PHOTO_DELETE: 'api/Model/PhotosGallery/Delete',

    BASE_URL_MAXSYSTEM: 'http://maxsystem.azurewebsites.net/',
    GENDER: 'api/Genders',
    HAIR_TYPE: 'api/HairTypes',
    HAIR_COLOR: 'api/HairColors',
    EYE_COLOR: 'api/EyeColors',
    SKIN_COLOR: 'api/SkinColors',
    CIVIL_STATUS: 'api/CivilStatus',
    CLOTH_SIZE: 'api/ClothSizes',
    FEATURE: 'api/Feature',
    SKILL: 'api/Skill',
    COURSE: 'api/Course',
    STATES: 'api/States',
    ZIPCODE: 'https://viacep.com.br/ws'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
